import type { TileConfig } from '../types/tiles'

export const DEFAULT_TILES: TileConfig[] = [
  { id: 'daily-briefing', component: 'DailyBriefing', colSpan: 2, rowSpan: 1 },
  { id: 'deep-work', component: 'DeepWork', colSpan: 2, rowSpan: 2 },
  { id: 'biometrics', component: 'Biometrics', colSpan: 2, rowSpan: 1 },
  { id: 'quick-actions', component: 'QuickActions', colSpan: 2, rowSpan: 1 },
  { id: 'quick-stats', component: 'QuickStats', colSpan: 2, rowSpan: 1 },
  { id: 'task-list', component: 'TaskList', colSpan: 2, rowSpan: 2 },
  { id: 'habit-tracker', component: 'HabitTracker', colSpan: 2, rowSpan: 2 },
  { id: 'water-intake', component: 'WaterIntake', colSpan: 2, rowSpan: 1 },
  { id: 'workflow-queue', component: 'WorkflowQueue', colSpan: 2, rowSpan: 2 },
  { id: 'daily-stoic', component: 'DailyStoic', colSpan: 2, rowSpan: 1 },
  { id: 'agenda', component: 'Agenda', colSpan: 2, rowSpan: 2 },
  { id: 'email', component: 'Email', colSpan: 2, rowSpan: 1 },
  { id: 'notes', component: 'Notes', colSpan: 2, rowSpan: 1 },
  { id: 'book-tracker', component: 'BookTracker', colSpan: 2, rowSpan: 1 },
]
